import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import UserAvatar from '../../../../components/UserAvatar';
import { hasGrants } from '../../../../js/me/selectors';
import ToolboxIcon from '../../../../components/icons/ToolboxIcon';
import PbxVirtualOperatorUserModalEdit from './PbxVirtualOperatorUserModalEdit';
import { getPbxEditingQueues } from '../../../../js/phone/selectors';
import LinkButton from '../../../../components/LinkButton';

const messages = defineMessages({
  editUser: {
    id: 'PbxVirtualOperatorUserRow.tooltip.editUser',
    defaultMessage: 'Edit',
  },
  showMore: {
    id: 'PbxVirtualOperatorUserRow.showMore',
    defaultMessage: 'Show more',
  },
  showLess: {
    id: 'PbxVirtualOperatorUserRow.showLess',
    defaultMessage: 'Show less',
  },
  BLIND: {
    id: 'PbxVirtualOperatorUserRow.BLIND',
    defaultMessage: 'Blind',
  },
  SUPERVISED: {
    id: 'PbxVirtualOperatorUserRow.SUPERVISED',
    defaultMessage: 'Supervised',
  },
  CONSULTATION: {
    id: 'PbxVirtualOperatorUserRow.CONSULTATION',
    defaultMessage: 'Consultation',
  },
});

const ROLE_CHARS = 200;

class PbxVirtualOperatorUserRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalEditOpen: false,
      showMore: false,
    };
  }

  toggleEditModal = () => {
    const { modalEditOpen } = this.state;
    this.setState({
      modalEditOpen: !modalEditOpen,
    });
  };

  render() {
    const {
      user,
      offices,
      canEdit,
      intl: { formatMessage },
    } = this.props;

    const selectedOffice = user.office && offices.find(
      (office) => office.queueId === user.office
    );

    return (
      <>
        <tr>
          <td>
            <UserAvatar
              size="md"
              alt={`${user.departmentFullname} avatar`}
              id={user.id}
              src={user.avatar}
              withPopover
            /><span className="ml-2">{user.departmentFullname}</span></td>
        <td>{user.enabled && <ToolboxIcon
                    name="check-circle-1-filled"
                    className="p-2"
                    style={{ top: '2px' }}
                  />}</td>
          <td>
            {user.alias}
          </td>
          <td>{selectedOffice ? `${selectedOffice.id}${
                selectedOffice.name && selectedOffice.name !== selectedOffice.id ? ` (${selectedOffice.name})` : ''
              }${selectedOffice.description ? ` - ${selectedOffice.description}` : ''}` : ''}</td>
          <td>
            <div
              style={{
                whiteSpace: 'break-spaces',
              }}
            >
              {this.state.showMore || !user.pronunciation || user.pronunciation.length < ROLE_CHARS ? (
                <React.Fragment>
                  <span>{user.pronunciation}</span>
                  {user.pronunciation && user.pronunciation.length > ROLE_CHARS && (
                    <LinkButton onClick={() => this.setState({ showMore: false })}>
                      {formatMessage(messages.showLess)}
                    </LinkButton>
                  )}
                </React.Fragment>
              ) : (
                <span>
                  {user.pronunciation.substring(0, ROLE_CHARS)}...
                  <LinkButton onClick={() => this.setState({ showMore: true })}>
                    {formatMessage(messages.showMore)}
                  </LinkButton>
                </span>
              )}
            </div>
          </td>
          <td>{user.transfer && formatMessage(messages[user.transfer])}</td>
          {canEdit && (
            <span onClick={() => this.toggleEditModal()}>
              <ToolboxIcon name="pencil-write-2">
                {formatMessage(messages.editUser)}
              </ToolboxIcon>
            </span>
          )}
        </tr>
        {this.state.modalEditOpen && (
          <PbxVirtualOperatorUserModalEdit
            isOpen={this.state.modalEditOpen}
            onClose={this.toggleEditModal}
            user={user}
          />
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    canEdit: hasGrants(state, 'MANAGE_VIRTUAL_OPERATOR'),
    offices: getPbxEditingQueues(state),
  };
}

export default injectIntl(connect(mapStateToProps)(PbxVirtualOperatorUserRow));
